import React from "react";

import { SkeletonBlock, SkeletonText } from "../Skeletons/primitives";

/**
 * Announcement list item skeleton — replaces the old absolute-positioned version.
 * Renders an icon placeholder + title + description lines, all using flex layout.
 */
const AnnouncementListLoader = () => {
  return (
    <div className="AnnouncementListLoader mb-4 w-full">
      <div
        className="flex items-start gap-4 rounded-lg p-4"
        style={{ background: "var(--skeleton-bg)", minHeight: 100 }}
      >
        {/* Icon placeholder */}
        <SkeletonBlock
          width={35}
          height={35}
          radius="lg"
          style={{ background: "var(--skeleton-shine)" }}
        />

        {/* Text content */}
        <div className="flex flex-1 flex-col gap-2">
          <SkeletonBlock
            width="35%"
            height={16}
            radius="sm"
            style={{ background: "var(--skeleton-shine)" }}
          />
          <SkeletonText lines={2} widths={["85%", "65%"]} size="md" />
        </div>
      </div>
    </div>
  );
};

export default AnnouncementListLoader;
